import React, { type PropsWithChildren, type JSX } from "react";
import { twMerge, twJoin } from "tailwind-merge";

import { SupText } from "../../../components/UI/Text";

export interface AssetLabelProps extends PropsWithChildren {
  className?: string;
  label: string | JSX.Element;
  subLabel?: string | JSX.Element;
  small?: boolean;
}

export function SupAssetLabel({ children, className, label, subLabel, small = false }: AssetLabelProps) {
  return (
    <div className={twMerge("sup-asset-label inline-flex gap-1", className)}>
      {children}
      <div className={twJoin("inline-flex flex-col justify-center items-start shrink-0", !small && "gap-1")}>
        {typeof label === "string" ? (
          <SupText as="span" variant={small ? "caption" : "button"}>
            {label}
          </SupText>
        ) : (
          label
        )}
        {typeof subLabel === "string" ? (
          <SupText as="span" variant="body2">
            {subLabel}
          </SupText>
        ) : (
          subLabel
        )}
      </div>
    </div>
  );
}
